export default {
	sitePolicy: {
		updateSingle:
			'We have updated our {link}, therefore you need to accept it again,',
		updateBoth:
			'To use the portal, you must first read and accept our {tos} and the {privacy}',
		userData:
			'and if necessary review {userLink}. Please note: if you have additional units or properties with other managers who also use HausPerfekt MOBILE, these terms may be presented to you again!',
		decline:
			'If you do {bold} agree to the terms, your personal data will be deleted from the portal and your manager will be informed.',
		yourData: 'Your data',
		tosAcknowledgement:
			'I have read and acknowledged the Terms and Conditions.',
		privacyAcknowledgement: 'I have read and acknowledged the Privacy Policy.',
		multipleUsers:
			'Multiple persons are linked to your email address. Please make a selection below.',
		userDataInfo:
			'The following data is stored in this portal about you or linked to your person.',
		acceptPrivacyTos:
			'Please accept the Privacy Policy and the Terms and Conditions before continuing.',
		portalUsage: 'Use of the Portal',
		formalGreeting: 'Dear Sir or Madam',
	},
}
